<template>
  <v-container grid-list-md>
    <div class="mt-4">
      <v-layout row wrap>
        <v-flex xs12 sm6 md4> 
          <router-link style="text-decoration: none;" to="/admin/students">
            <v-card color="blue" class="white--text">
              <v-container fluid grid-list-lg >
                <v-layout class="text-xs-center">
                  <v-flex xs6 justify-center align-content-center>
                    <v-icon style="font-size: 72px;">group</v-icon>
                  </v-flex>
                  <v-flex xs6>
                    <div>
                      <div class="display-1">{{noOfStudents}}</div>
                      <div class="headline" style="font-weight:300;">Students</div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </router-link>
        </v-flex>
        
        <v-flex xs12 sm6 md4>
          <router-link style="text-decoration: none;" to="/admin/instructors">
            <v-card color="green" class="white--text">
              <v-container fluid grid-list-lg >
                <v-layout class="text-xs-center">
                  <v-flex xs6 justify-center align-content-center>
                    <v-icon style="font-size: 72px;">people_outline</v-icon>
                  </v-flex>
                  <v-flex xs6>
                    <div>
                      <div class="display-1">{{ noOfInstructors }}</div>
                      <div class="headline" style="font-weight:300;">Instructors</div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </router-link>
        </v-flex>
        
        <v-flex xs12 sm6 md4>
          <v-card color="red lighten-1" class="white--text">
            <v-container fluid grid-list-lg >
              <v-layout class="text-xs-center">
                <v-flex xs6 justify-center align-content-center>
                  <v-icon style="font-size: 72px;">school</v-icon>
                </v-flex>
                <v-flex xs6>
                  <div>
                    <div class="display-1">'18-'19</div>
                    <div class="headline" style="font-weight:300;">School Year</div>
                  </div>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </div>


    <div class="mt-4">
      <not-verified class="mt-2"></not-verified>
    </div>

    <div class="mt-4">
      <h1 class="headline">Gender Distribution</h1>
      <v-divider></v-divider>
      <v-layout row wrap class="mt-2">
        <v-flex xs12 md6>
          <v-card class="elevation-3">
            <student-gender></student-gender>
          </v-card>
        </v-flex>
        <v-flex xs12 md6>
          <v-card class="elevation-3">
            <instructor-gender></instructor-gender>
          </v-card>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios'
import StudentGender from '../Charts/StudentGender.vue'
import InstructorGender from '../Charts/InstructorGender.vue'
import NotVerified from './Dashboard/NotVerified.vue'
export default {
  components: { StudentGender, InstructorGender, NotVerified },
  created(){
    this.$store.dispatch('admin/FETCH_INSTRUCTORS')
    this.$store.dispatch('admin/FETCH_STUDENTS')
  },
  computed: {
    noOfStudents(){
      return this.$store.getters['admin/GET_STUDENTS'].filter(item => item.verified ? item : null).length
    },
    noOfInstructors(){
      return this.$store.getters['admin/GET_INSTRUCTORS'].filter(item => item.verified ? item : null).length
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Dashboard.vue